import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface PagesBaseSignature {
  // The arguments accepted by the component
  Args: {};
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class PagesBaseComponent extends Component<PagesBaseSignature> {
  /** jscpd:ignore-start */
  @tracked elements: object[] = [
    {
      url: '/a-propos-de-triptyk#team',
      text: 'L’équipe de TRIPTYK',
    },
    {
      url: '/a-propos-de-triptyk#love',
      text: 'La culture d’entreprise TRIPTYK',
    },
    {
      url: 'https://reaktiv.be/',
      text: 'Reaktiv',
      target: '_blank',
    },
    {
      url: 'https://mediacio.be/',
      text: 'Mediacio',
      target: '_blank',
    },
    {
      url: 'https://rgpd-check.eu/',
      text: 'RGPD-Check',
      target: '_blank',
    },
    {
      url: 'https://github.com/TRIPTYK',
      text: 'Le Github de TRIPTYK',
      target: '_blank',
    },
    {
      url: 'realisations/technocite',
      text: 'Technocité',
    },
    {
      url: 'realisations/abex',
      text: 'Abex',
    },
    {
      url: 'realisations/bluewhite',
      text: 'Bluewhite',
    },
    {
      url: 'realisations/mediacio',
      text: 'mediacio',
    },
    {
      url: 'realisations/crehopa',
      text: 'Crehopa',
    },
  ];
  /** jscpd:ignore-end */
}
